export default function arrayOf<T>(length: number, value: T | ((i: number) => T)): T[] {
  return Array.from({ length }, (v, k) => {
    return value instanceof Function ? value(k) : value;
  });
}
